var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 160 140",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "80",
      "cy": "128",
      "rx": "58",
      "ry": "8",
      "fill": "#eef0fb"
    }
  }), _c('circle', {
    attrs: {
      "cx": "80",
      "cy": "66",
      "r": "61",
      "fill": "#f0edff"
    }
  }), _c('rect', {
    attrs: {
      "x": "30",
      "y": "27",
      "width": "96",
      "height": "91",
      "rx": "12",
      "fill": "white",
      "stroke": "#c6bbff",
      "stroke-width": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "M42 27h72a12 12 0 0 1 12 12v17H30V39a12 12 0 0 1 12-12",
      "fill": "#7055e8"
    }
  }), _c('path', {
    attrs: {
      "d": "M53 20v18m50-18v18",
      "stroke": "#3d2a88",
      "stroke-width": "5",
      "stroke-linecap": "round"
    }
  }), _c('g', {
    attrs: {
      "fill": "#ddd6fa"
    }
  }, [_c('rect', {
    attrs: {
      "x": "45",
      "y": "68",
      "width": "12",
      "height": "10",
      "rx": "3"
    }
  }), _c('rect', {
    attrs: {
      "x": "67",
      "y": "68",
      "width": "12",
      "height": "10",
      "rx": "3"
    }
  }), _c('rect', {
    attrs: {
      "x": "89",
      "y": "68",
      "width": "12",
      "height": "10",
      "rx": "3"
    }
  }), _c('rect', {
    attrs: {
      "x": "45",
      "y": "89",
      "width": "12",
      "height": "10",
      "rx": "3"
    }
  }), _c('rect', {
    attrs: {
      "x": "67",
      "y": "89",
      "width": "12",
      "height": "10",
      "rx": "3"
    }
  })]), _c('circle', {
    attrs: {
      "cx": "117",
      "cy": "105",
      "r": "23",
      "fill": "#fff",
      "stroke": "#7055e8",
      "stroke-width": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "M117 92v14l9 5",
      "fill": "none",
      "stroke": "#7055e8",
      "stroke-width": "3",
      "stroke-linecap": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }